import * as React from "react";
import { Group } from "@vx/group";
import { Circle } from "@vx/shape";
import { Text } from "@vx/text";
export type LegendEntry = {
  fill: string;
  label: string;
};

export interface Props {
  entries: LegendEntry[];
}

export default function GraphLegend({ entries }: Props) {
  const width = 100;
  const entryHeight = 20;
  const height = entryHeight * entries.length;

  return (
    <>
      {entries.map((entry, n) => (
        <Group key={n} left={0} top={n * entryHeight}>
          <Circle r={4} fill={entry.fill} />
          <Text dx={8} verticalAnchor="middle" fontSize="11px">
            {entry.label}
          </Text>
        </Group>
      ))}
    </>
  );
}
